<div class="container modal-milestone-content main-wrapper">
    <button (click)="close()"
            aria-label="Close"
            class="create-modal-close-icon"
            data-dismiss="modal"
            id="closetooltipModalButton">
        <svg class="svg-icon svg-icon-Close" viewBox="0 0 20.13 19.5" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9,12.2V12l7.7-7.1.1-.1a1.3,1.3,0,0,0-.1-1.9,1.45,1.45,0,0,0-2.1,0L12.1,9.7l-7.5-7a1.57,1.57,0,0,0-2.2,0h0l-.1.1a1.51,1.51,0,0,0,.1,1.9l7.7,7.2v.2L2.4,19.2l-.1.1a1.3,1.3,0,0,0,.1,1.9,1.45,1.45,0,0,0,2.1,0l7.4-6.8,7.5,6.9a1.45,1.45,0,0,0,2.1,0l.1-.1a1.3,1.3,0,0,0-.1-1.9Z"
                  transform="translate(-1.94 -2.25)"/>
        </svg>
    </button>
    <div class="flex-center" role="img">
        <img alt="" class="mt36 mb10" src="ocsp-web-ui/dist/assets/images/freshpassSubscriber.svg">
    </div>
    <div class="milestone-title text-align-center mb16">
        <div><span id="milestoneSavingsAmountTitle">${{ celebrationAmount || 0}}</span> {{properties.confirmation.SAVED_AND_COUNTING}}</div>
    </div>
    <div class="milestone-details fs16 mb24">
        <div aria-live="polite" class="">{{properties.confirmation.CONGRATS_YOU_VE_SAVED}} <span
                id="milestoneSavingsAmountDetails">${{ celebrationAmount || 0 }}</span> {{properties.confirmation.WITH_FRESH_PASS}}
        </div>
        <div aria-live="polite" class=""> {{properties.confirmation.WE_HOPE_YOU_RE_ENJOYING_THE_PERKS_AND_THE_SAVINGS}}</div>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="mx-auto">
                <button (click)="close()"
                        class="btn btn-default milestone-modal-button"
                        data-dismiss="modal"
                        id="doneBtn"
                        tabindex="0">
                        {{properties.confirmation.OK_GOT_IT}}
                </button>
            </div>
        </div>
    </div>
</div>
